// extracted by mini-css-extract-plugin
module.exports = {"introBox":"styles_introBox__2fdVD","innerContainer":"styles_innerContainer__2VVme","text":"styles_text__n_ULD","modalContainer":"styles_modalContainer__1Pquo"};